import { CivilityOption, StaticOption, StaticOptionsMap, TitleOption, UserData } from './_props'

export const civilitiesMap: StaticOptionsMap<CivilityOption> = {
    m: {
        value: 'M',
        label: 'Monsieur',
    },
    mme: {
        value: 'MME',
        label: 'Madame',
    },
}

export const titlesMap: StaticOptionsMap<TitleOption> = {
    none: {
        value: 'Aucun',
        label: 'Aucun',
    },
    dr: {
        value: 'Dr',
        label: 'Docteur',
    },
    pr: {
        value: 'Pr',
        label: 'Professeur',
    },
}

const civilities = Object.keys(civilitiesMap).reduce<StaticOption[]>((prev, curr) => {
    const option = civilitiesMap[curr as CivilityOption]
    if (option) {
        prev.push(option)
    }

    return prev
}, [])

const titles = Object.keys(titlesMap).reduce<StaticOption[]>((prev, curr) => {
    const option = titlesMap[curr as TitleOption]
    if (option) {
        prev.push(option)
    }
    return prev
}, [])

const emptyData: UserData = {
    objectId: '',
    civility: '',
    lastName: '',
    firstName: '',
    email: '',
    initialEmail: '',
    password: '',
    title: titlesMap.none.value,
    privatePhone: '',
    contactPhone: '',
    profession: '',
    professionId: '',
    qualificationId: '',
    specialityId: '',
    speMentions: [],
    qualification: '',
    speciality: '',
    positionName: '',
    rpps: '',
    idnps: '',
    categoryList: [],
    securedEmail: '',
    isEmployee: undefined,
    extraHealthActivityInfoId: '',
    extraHealthSystemInfoId: '',
    extraUsageInfoObjectId: '',
    technicalConfigObjectId: '',
    positionId: '',
    isTransEnabled: undefined,
    hcsDelegateUserId: '',
    addressObjectId: '',
    bankInfoObjectId: '',
    userHcsPositionId: '',
    activated: false,
    status: {
        manager: false,
        simple: false,
    },
    validRpps: false,
    notification: {
        email: false,
        sms: false,
    },
    realEmail: true,
    qualificationPointer: undefined,
    professionPointer: undefined,
    specialityPointer: undefined,
    positionPointer: undefined,
    role: undefined,
}

const mandatoryFields = ['civility', 'name', 'firstName', 'qualification', 'profession', 'mail']

const initialErrorState = {
    civility: false,
    name: false,
    firstName: false,
    qualification: false,
    profession: false,
    mail: false,
    privatePhone: false,
    contactPhone: false,
}

export { civilities, titles, emptyData, mandatoryFields, initialErrorState }
